// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__LczvA{
    padding: 2rem !important;
}

.style_paper__3I7Oh{
    padding: 1rem !important;
    
}

.style_title__P5BIy{
    color: #18316e !important;
    display: flex !important;
    justify-content: space-between !important;
}

.style_card__4P8GC{
    border: 1px solid #c7c7c7;
    border-radius: 8px;
    box-shadow: 2px 2px 5px #c7c7c7;
    margin-top: 1rem;
    padding: 0 .5rem;
}

.style_card_qtd__W-7E2{
    background-color: #18316e;
    border: 1px solid #c7c7c7;
    border-radius: 8px;
    box-shadow: 2px 2px 5px #c7c7c7;
    color: white;
    display: flex;
    justify-content: space-around;
    margin-top: 1rem;
    padding: .5rem;
}
.style_card_qtd_sucesso__quSjp{
    background-color: #24a034;
    border: 1px solid #c7c7c7;
    border-radius: 8px;
    box-shadow: 2px 2px 5px #c7c7c7;
    color: white;
    display: flex;
    justify-content: space-around;
    margin-top: 1rem;
    padding: .5rem;
}
.style_card_qtd_falha__VwXOM{
    background-color: #921313;
    border: 1px solid #c7c7c7;
    border-radius: 8px;
    box-shadow: 2px 2px 5px #c7c7c7;
    color: white;
    display: flex;
    justify-content: space-around;
    margin-top: 1rem;
    padding: .5rem;
}

.style_card_qtd_item__NsMTL{
    text-align: center;
}

.style_tableHeader__6TUpf{
    color: #18316e !important;
    font-size: 1rem !important;
    font-weight: bold !important;
}

.style_loading__jFxaH{
    align-items: center;
    display: flex;
    height: 100vh;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/VamosVencerJuntos/style.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B","sourcesContent":[".container{\n    padding: 2rem !important;\n}\n\n.paper{\n    padding: 1rem !important;\n    \n}\n\n.title{\n    color: #18316e !important;\n    display: flex !important;\n    justify-content: space-between !important;\n}\n\n.card{\n    border: 1px solid #c7c7c7;\n    border-radius: 8px;\n    box-shadow: 2px 2px 5px #c7c7c7;\n    margin-top: 1rem;\n    padding: 0 .5rem;\n}\n\n.card_qtd{\n    background-color: #18316e;\n    border: 1px solid #c7c7c7;\n    border-radius: 8px;\n    box-shadow: 2px 2px 5px #c7c7c7;\n    color: white;\n    display: flex;\n    justify-content: space-around;\n    margin-top: 1rem;\n    padding: .5rem;\n}\n.card_qtd_sucesso{\n    background-color: #24a034;\n    border: 1px solid #c7c7c7;\n    border-radius: 8px;\n    box-shadow: 2px 2px 5px #c7c7c7;\n    color: white;\n    display: flex;\n    justify-content: space-around;\n    margin-top: 1rem;\n    padding: .5rem;\n}\n.card_qtd_falha{\n    background-color: #921313;\n    border: 1px solid #c7c7c7;\n    border-radius: 8px;\n    box-shadow: 2px 2px 5px #c7c7c7;\n    color: white;\n    display: flex;\n    justify-content: space-around;\n    margin-top: 1rem;\n    padding: .5rem;\n}\n\n.card_qtd_item{\n    text-align: center;\n}\n\n.tableHeader{\n    color: #18316e !important;\n    font-size: 1rem !important;\n    font-weight: bold !important;\n}\n\n.loading{\n    align-items: center;\n    display: flex;\n    height: 100vh;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__LczvA`,
	"paper": `style_paper__3I7Oh`,
	"title": `style_title__P5BIy`,
	"card": `style_card__4P8GC`,
	"card_qtd": `style_card_qtd__W-7E2`,
	"card_qtd_sucesso": `style_card_qtd_sucesso__quSjp`,
	"card_qtd_falha": `style_card_qtd_falha__VwXOM`,
	"card_qtd_item": `style_card_qtd_item__NsMTL`,
	"tableHeader": `style_tableHeader__6TUpf`,
	"loading": `style_loading__jFxaH`
};
export default ___CSS_LOADER_EXPORT___;
